<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onMounted, onUnmounted} from 'vue';
import { useAuthStore } from './stores/authStore';

const authStore = useAuthStore();

const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

const handleActivity = () => {
  authStore.resetInactivityTimer();
};

onMounted(async () => {

  activityEvents.forEach(event => {
    window.addEventListener(event, handleActivity);
  });

  authStore.resetInactivityTimer();

  if (localStorage.getItem('activeUserID')) {
    
    await authStore.fetchUser();
  }
});

onUnmounted(() => {
  activityEvents.forEach(event => {
    window.removeEventListener(event, handleActivity);
  });
});
</script>

<template>
 <div class="h-full">
   <RouterView />
 </div>
</template>


